<div class="container">
  <div class="row">
    <div class="col-12">
      <form [formGroup]="trackingForm" (ngSubmit)="onSubmit()">
        <div class="row tracking d-flex justify-content-center">
          <div class="col-12 col-md-4 d-flex justify-content-center">
            <div class="form-group mx-sm-3 mb-2">
              <label for="trackingInput" class="sr-only">Número de tracking</label>
              <input type="text" class="form-control input-tracking" id="trackinInput" placeholder="Número de tracking"
                formControlName="searchCode">
            </div>
          </div>
          <div class="col-12 col-md-3 d-flex justify-content-center">
            <div class="mt-3 mt-md-0">
              <button type="submit" class="btn btn-primary rounded btn-sm">
                Buscar mi pedido
              </button>
              <div *ngIf="submitted && f.searchCode.errors?.required" class="invalid-feedback d-block">
                Ingrese número de tracking
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12">
      <div class="d-flex flex-column">
        <img src="assets/images/delivery_truck.JPG" alt="" class="mx-auto d-block" style="height: 100px;">
        <h1 class="font-weight-bolder text-black-50 mt-3 mb-5">Estatus de tracking</h1>
        <div class="alert alert-danger align-self-center" role="alert" [hidden]="notFound">
          No hay registro con ese número de tracking
        </div>
        <div *ngFor="let status of statuses; let i=index">
          <div class="alert alert-info text-center" role="alert" *ngIf="i+1 === idStatusPackage">
            Status del paquete: <strong>{{status}}</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mx-auto mt-2 mt-md-5">
      <div class="col-12">
        <div class="flex-parent">
          <div class="input-flex-container">
            <div class="input" [ngClass]="{'active': idStatusPackage === 0}">
              <!-- <span data-info="Prealertar"></span> -->
            </div>
            <div class="input" [ngClass]="{'active': idStatusPackage === 6}">
              <span data-info="Prealertar"></span>
            </div>
            <div class="input" [ngClass]="{'active': idStatusPackage === 1}">
              <span data-info="En Miami"></span>
            </div>
            <div class="input" [ngClass]="{'active': idStatusPackage === 2}">
              <span data-info="En transito"></span>
            </div>
            <div class="input" [ngClass]="{'active': idStatusPackage === 3}">
              <span data-info="Listo para entrega"></span>
            </div>
            <div class="input" [ngClass]="{'active': idStatusPackage === 4}">
              <span data-info="En camino a reparto"></span>
            </div>
            <div class="input" [ngClass]="{'active': idStatusPackage === 5}">
              <span data-info="Entregado"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>